import { ComponentProps, ElementType } from 'react';

import { Link } from '@mui/material';
import { ExtraProps } from 'react-markdown';

import Tooltip from '@/components/Tooltip';
import Typography from '@/components/Typography';

export const MarkdownLink: ElementType<ComponentProps<'a'> & ExtraProps> = ({ node, ...props }) => (
  <Tooltip
    title='Click to see index information'
    variant='secondary'
  >
    <Link
      {...props}
      color='textPrimary'
      rel='noopener noreferrer'
      target='_blank'
    />
  </Tooltip>
);

export const MarkdownH1: ElementType<ComponentProps<'h1'> & ExtraProps> = ({ node, ...props }) => (
  <Typography
    sx={{
      fontSize: '20px',
      margin: '20px 0',
      fontWeight: 700
    }}
    variant='h1'
    {...props}
  />
);

export const MarkdownH2: ElementType<ComponentProps<'h2'> & ExtraProps> = ({ node, ...props }) => (
  <Typography
    sx={{
      fontSize: '16px',
      margin: '20px 0',
      fontWeight: 700
    }}
    variant='h2'
    {...props}
  />
);

export const MarkdownH3: ElementType<ComponentProps<'h3'> & ExtraProps> = ({ node, ...props }) => (
  <Typography
    sx={{
      fontSize: '14px',
      margin: '20px 0',
      fontWeight: 700
    }}
    variant='h3'
    {...props}
  />
);
